let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cpWvb")).then(() => parcelRequire('lj4xl'));